import { type ReactNode, forwardRef } from 'react';
import { View, type ViewProps } from 'react-native';

/**
 * FlashList wraps each row in a cell root that can surface as an unnamed “group” to
 * VoiceOver on web. Mark the cell container as non-semantic so the labeled control inside
 * (e.g. ProductListTile) is what hover/VO targets.
 */
export type NonSemanticFlashListCellProps = ViewProps & { children?: ReactNode };

export const NonSemanticFlashListCell = forwardRef<View, NonSemanticFlashListCellProps>(
  function NonSemanticFlashListCell({ children, ...rest }, ref) {
    return (
      <View ref={ref} {...rest} accessible={false} accessibilityRole="none">
        {children}
      </View>
    );
  }
);
